var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "v-container",
        [
          _c(
            "h2",
            {
              staticClass: "myTitle hidden-sm-and-down text-left",
              staticStyle: { "margin-bottom": "0" },
            },
            [_vm._v("Registrierung")]
          ),
          _c("div", { staticClass: "spacer-15 hidden-md-and-up" }),
          _c(
            "v-form",
            {
              ref: "form",
              staticClass: "registerForm bigger-input",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "indented",
                  staticStyle: { "padding-top": "0" },
                },
                [
                  _c("h3", [_vm._v("Wie können wir Dich erreichen?")]),
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.nameRules,
                      label: "Vor- und Nachname *",
                      placeholder: "Vorname Nachname",
                      "hide-details": "",
                      illed: "",
                      required: "",
                    },
                    on: { focus: _vm.hideToolbar, blur: _vm.unhideToolbar },
                    model: {
                      value: _vm.formData.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "name", $$v)
                      },
                      expression: "formData.name",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      type: "email",
                      rules: _vm.emailRules,
                      label: "E-Mail* (Bestelleingangsbestätigung)",
                      placeholder: "Für eine Kopie deiner Bestellung",
                      "hide-details": "",
                      illed: "",
                      required: "",
                    },
                    on: { focus: _vm.hideToolbar, blur: _vm.unhideToolbar },
                    model: {
                      value: _vm.formData.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email",
                    },
                  }),
                  _c("v-text-field", {
                    ref: "phone",
                    attrs: {
                      rules: _vm.phoneRules,
                      label: "Mobilnummer*",
                      placeholder: "",
                      illed: "",
                      required: "",
                    },
                    on: {
                      keydown: function ($event) {
                        return _vm.phoneKeydown($event)
                      },
                    },
                    model: {
                      value: _vm.formData.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "phone", $$v)
                      },
                      expression: "formData.phone",
                    },
                  }),
                  _c("p", [_vm._v("Hinweis: Du erhälst keine Werbe-Anrufe!")]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "indented" },
                [
                  _c("h3", [_vm._v("Rechnungsadresse")]),
                  _vm.formData.invoiceAddress.company.length === 0
                    ? _c("v-text-field", {
                        attrs: {
                          label: "Vor- und Nachname",
                          "hide-details": "",
                          illed: "",
                        },
                        model: {
                          value: _vm.formData.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "name", $$v)
                          },
                          expression: "formData.name",
                        },
                      })
                    : _vm._e(),
                  _c("v-text-field", {
                    attrs: {
                      label: "Firma (optional)",
                      "hide-details": "",
                      illed: "",
                      outline: "",
                    },
                    model: {
                      value: _vm.formData.invoiceAddress.company,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.invoiceAddress, "company", $$v)
                      },
                      expression: "formData.invoiceAddress.company",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: "Straße und Hausnummer",
                      "hide-details": "",
                      illed: "",
                    },
                    model: {
                      value: _vm.formData.invoiceAddress.street,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData.invoiceAddress, "street", $$v)
                      },
                      expression: "formData.invoiceAddress.street",
                    },
                  }),
                  _c("table", { staticClass: "maxw myTable" }, [
                    _c("tr", [
                      _c(
                        "td",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "PLZ",
                              "hide-details": "",
                              illed: "",
                            },
                            model: {
                              value: _vm.formData.invoiceAddress.plz,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.invoiceAddress,
                                  "plz",
                                  $$v
                                )
                              },
                              expression: "formData.invoiceAddress.plz",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Ort",
                              "hide-details": "",
                              illed: "",
                            },
                            model: {
                              value: _vm.formData.invoiceAddress.city,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData.invoiceAddress,
                                  "city",
                                  $$v
                                )
                              },
                              expression: "formData.invoiceAddress.city",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm.$store.getters.loggedIn === false
                ? _c(
                    "div",
                    { staticClass: "indented" },
                    [
                      _c("h3", [_vm._v("Wähle Dein Passwort")]),
                      _c("v-text-field", {
                        attrs: {
                          label: "Passwort (mind. 6 Zeichen)",
                          type: _vm.show1 ? "text" : "password",
                          "append-icon": _vm.show1
                            ? "mdi-eye-outline"
                            : "mdi-eye-off-outline",
                          "hide-details": "",
                          illed: "",
                          required: "",
                        },
                        on: {
                          "click:append": function ($event) {
                            _vm.show1 = !_vm.show1
                          },
                          focus: _vm.hideToolbar,
                          blur: _vm.unhideToolbar,
                        },
                        model: {
                          value: _vm.formData.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "password", $$v)
                          },
                          expression: "formData.password",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "spacer-25" }),
              _vm.displayErrors.length > 0 && _vm.initialTry
                ? _c("div", {
                    staticClass: "error--text mt-2 mr-4",
                    domProps: { innerHTML: _vm._s(_vm.displayErrors) },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-wrap align-center justify-sm-start",
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-df mr-5 mt-5",
                      attrs: { large: "", rounded: "" },
                      on: {
                        disabled: _vm.process.submitted,
                        click: _vm.doRegister,
                      },
                    },
                    [_vm._v("Registrieren ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-none btn-mini mr-5 mt-5",
                      attrs: { rounded: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.gotoSignin.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" Bereits registriert? ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { padding: "0 16px" } },
            [
              _c("agb-consent", {
                attrs: { "button-name": "Kostenlos registrieren" },
              }),
            ],
            1
          ),
          _c("ssl-seal"),
          _c("sms-dialog", {
            attrs: { dialog: _vm.smsDialog },
            on: {
              close: function ($event) {
                _vm.smsDialog = false
              },
              cancleDialog: _vm.cancleDialog,
              verifySmsCode: _vm.verifySms,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }